// @flow

import styled from "styled-components";

import * as colors from "src/styles/constants/colors";

export const Reports = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  font-size: 14px;
  color: ${(props) => props.color || colors.primary};
`;

export const ReportLinkButton = styled.button`
  background: none;
  border: none;
  padding: 0;
  font-size: inherit;
  font-family: inherit;
  color: ${(props) => props.color || colors.primary};
  text-decoration: underline;
  cursor: pointer;
  text-align: left;

  &:hover,
  &:focus {
    opacity: 0.8;
    outline: none;
  }
`;
